<script>
import BaseChart from '@/components/dashboard/charts/BaseChart'

export default BaseChart.extend({
  name: 'pie-chart',

  data () {
    return {
      type: 'pie',
      chartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        animation: {
          animateRotate: true,
          animateScale: true
        },
        cutoutPercentage: 0
      }
    }
  },

  computed: {
    values () {
      // FIXME: Order is not guaranteed
      return Object.values(this.$store.getters.pieChartData)
    },

    labels () {
      // FIXME: Order is not guaranteed
      return Object.keys(this.$store.getters.pieChartData)
    },

    chartData () {
      return {
        type: this.type,
        data: {
          labels: this.labels,
          datasets: [{
            data: this.values,
            backgroundColor: this.getColors('transparent', this.values.length),
            borderColor: this.getColors('solid', this.values.length),
            borderWidth: 1
          }]
        },
        options: this.chartOptions
      }
    }
  },

  beforeDestroy () {
    /** Remove any event listeners */
    this.eventHub.$off('groupCourseCohortFilterUpdated')
  },

  mounted () {
    /** Listen for when Progress Buckets are updated */
    this.eventHub.$on('groupCourseCohortFilterUpdated', this.refresh)

    this.errorCheck()

    this.render(this.chartData)
  },

  methods: {
    errorCheck () {
      if (
        // eslint-disable-next-line
        _.isEqual(this.$store.state.selectedGroup, {}) ||
        this.$store.state.selectedGroupCourses.length === 0
      ) {
        this.errorBag = {
          status: 'danger',
          message: 'Please select at least 1 Group and 1 Course at the top.'
        }
      } else {
        this.errorBag = {
          status: '',
          message: ''
        }
      }
    }
  }
})
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/dashboard/charts/PieChart.vue